import { Injectable } from '@angular/core'

import { MenuItem } from '@mprep/shared/data/models'
import { ModelRepository, ModelRepositoryAdapter } from '@mprep/shared'

@Injectable()
export class MenuItemService extends ModelRepositoryAdapter<MenuItem> {

  constructor(
    _modelRepository: ModelRepository
  ) {
    super(_modelRepository, MenuItem)
    // TODO [GitHub Issue]: Verify that this really preloads
    this.initialize(['menuItems.menuItems.menuItems'])
  }

  public initialize(_args) {}

  public findAllModels(includeRelations: string[] = ['menuItems.menuItems.menuItems']) {
    return super.findAllModels(includeRelations)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/menu-item.service.ts